import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

window.addEventListener('beforeinstallprompt', event => {
  event.preventDefault();
  window.readTheWordInstallPrompt = event;
});
window.addEventListener('appinstalled', () => { window.readTheWordInstallPrompt = null; });

// Network-only app/API requests keep releases and account data fresh. The worker
// provides a dedicated offline page, without caching Scripture or private data.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(error => {
      console.warn('Offline support could not be registered:', error);
    });
  });
}
